import React from 'react';
import PropTypes from 'prop-types';

import ProfileCardLink from '../../components/ProfileCardLink/ProfileCardLink';
import SkeletonLoader from '../../components/SkeletonLoader/SkeletonLoader';
import ListZeroState from '../../components/ListZeroState';
import { t } from '../../i18n';
import s from './ConnectionsCompanyPage.module.scss';

const SKELETON_ROWS = 4;

export const IndividualsTab = ({
    individuals = [],
    isLoading = false,
    hasError = false,
}) => {
    if (isLoading) {
        return (
            <div className={s.Tab}>
                <div className={s.Individuals}>
                    {Array.from({ length: SKELETON_ROWS }, (_, index) => (
                        <div className={s.IndividualSkeleton} key={index}>
                            <SkeletonLoader />
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    if (hasError) {
        return (
            <div className={s.ZeroStateWrapper}>
                <ListZeroState
                    title={t('connectionsCompanyPage.chartErrorLabel')}
                    text={t('connectionsCompanyPage.chartErrorText')}
                />
            </div>
        );
    }

    if (individuals.length === 0) {
        return (
            <div className={s.ZeroStateWrapper}>
                <ListZeroState
                    title={t('connectionsPage.holdings.noIndividualsLabel')}
                    text={t('connectionsV2Page.zeroStateHint')}
                />
            </div>
        );
    }

    return (
        <div className={s.Tab}>
            <div className={s.Individuals}>
                {individuals.map((individual) => (
                    <ProfileCardLink
                        {...individual}
                        isWhite
                        key={
                            individual.primaryKey_ ||
                            individual.url ||
                            individual.name
                        }
                    />
                ))}
            </div>
        </div>
    );
};

IndividualsTab.propTypes = {
    individuals: PropTypes.array,
    isLoading: PropTypes.bool,
    hasError: PropTypes.bool,
};
